import { Box, Image, Text } from "@chakra-ui/react";
import { getInitials } from "@utils/utils";

interface Props {
	url?: string;
	name?: string;
	size?: string;
	placeholderFontSize?: string;
}

const ConsultantImage: React.FC<Props> = ({ url, name, size = "150px", placeholderFontSize = "xl" }) => {
	return (
		<Image
			borderRadius="full"
			border={"1.5px solid #2A2A2A"}
			boxSize={size}
			minW={size}
			src={url}
			alt={name}
			fit={"cover"}
			fallback={
				<Box
					boxSize={size}
					minW={size}
					borderRadius="full"
					border={"1.5px solid #2A2A2A"}
					bg="gray.200"
					display={"flex"}
					justifyContent={"center"}
					alignItems={"center"}
				>
					<Text fontSize={placeholderFontSize} color="gray.500" m="0" as="span">
						{getInitials(name)}
					</Text>
				</Box>
			}
		/>
	);
};

export default ConsultantImage;
